import { GlobalState } from "little-state-machine";
import { RolesEnum } from "modules/rolesEnum";

export const updateUserRole = (
  state: GlobalState,
  userRole: RolesEnum | undefined
) => ({
  ...state,
  userRole
});
